import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const secretKey = "mySecretKey123"; // Same secret key

const SecureViewer = () => {
  const navigate = useNavigate();
  const [iframeUrl, setIframeUrl] = useState("");

  useEffect(() => {
    const encryptedUrl = sessionStorage.getItem("secureNavaticURL"); // Retrieve encrypted URL

    if (encryptedUrl) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedUrl, secretKey);
        const decryptedUrl = bytes.toString(CryptoJS.enc.Utf8);

        if (decryptedUrl) {
          setIframeUrl(decryptedUrl); // Set the iframe URL
        } else {
          navigate("/"); // Redirect to home if decryption fails
        }
      } catch (error) {
        console.error("Decryption error:", error);
        navigate("/"); // Redirect if error
      }
    } else {
      navigate("/"); // Redirect if no URL is found
    }
  }, [navigate]);


  useEffect(() => {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    document.addEventListener("keydown", (event) => {
      if (event.ctrlKey && (event.key === "u" || event.key === "s" || event.key === "c")) {
        event.preventDefault();
      }
    });
  }, []);
  

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      ) : (
        <h3>Loading Demo...</h3>
      )}
    </div>
  );
};

export default SecureViewer;
